module.exports = __webpack_public_path__ + "static/img/quad-default.ea368bf7.png";